import {
  CarrierVisitDirection,
  ContainerTurnoverBasicInfoDto,
  ContainerTurnoverDto,
  ContainerTurnoverDtoPaginatedList,
  ContainerTurnoversApi,
  ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest,
  ContainerTurnoversApiContainerTurnoversGetAllRequest,
  ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest,
  ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest,
  ContainerTurnoversApiContainerTurnoversGetDetailsRequest,
  ContainerYardOperationDto,
  DeviceOperationMode,
  SuggestedContainerDto,
} from '@storage/app/api'

export class ContainerTurnoverService {
  constructor(private api: ContainerTurnoversApi) {}

  async getAll(
    containerTurnoversApiGetAllRequest: ContainerTurnoversApiContainerTurnoversGetAllRequest,
  ): Promise<ContainerTurnoverDtoPaginatedList> {
    const { data: containerTurnovers } = await this.api.containerTurnoversGetAll(containerTurnoversApiGetAllRequest)

    return containerTurnovers
  }

  async getTurnover(containerTurnoverGetDetailsRequest: ContainerTurnoversApiContainerTurnoversGetDetailsRequest) {
    const { data: containerTurnover } = await this.api.containerTurnoversGetDetails(
      containerTurnoverGetDetailsRequest,
    )

    return containerTurnover
  }

  async getContainerPositionByNumber(
    containerTurnoverGetDetailsRequest: ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest,
  ) {
    const { data: containers } = await this.api.containerTurnoversGetContainerPositionByNumber(
      containerTurnoverGetDetailsRequest,
    )

    return containers
  }

  async getAllBasicInfo(
    containerTurnoversApiGetAllBasicInfoRequest: ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest,
  ): Promise<ContainerTurnoverBasicInfoDto[]> {
    const { data: containerTurnovers } = await this.api.containerTurnoversGetAllBasicInfo(
      containerTurnoversApiGetAllBasicInfoRequest,
    )

    return containerTurnovers
  }

  async getByOrderId(
    request: ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest,
  ): Promise<ContainerTurnoverDto> {
    const { data: containerTurnover } = await this.api.containerTurnoversGetByOrderId(request)

    return containerTurnover
  }

  async getCarrierVisitContainerTurnovers(
    carrierVisitId: number,
    direction: CarrierVisitDirection,
  ) {
    const { data: containerTurnovers } = await this.api.containerTurnoversGetContainerTurnoversByCarrierVisit({
      carrierVisitId,
      direction,
    })

    return containerTurnovers
  }

  async getYardOperationData(
    containerNumber?: string,
    orderId?: number,
    isStackIn?: boolean,
    mode?: DeviceOperationMode,
  ): Promise<ContainerYardOperationDto> {
    const { data: yardOperationData } = await this.api.containerTurnoversGetYardOperationData({
      containerNumber,
      orderId,
      isStackIn,
      mode,
    })
    return yardOperationData
  }

  async getTurnoversByCarrierDirection(
    direction: CarrierVisitDirection,
  ): Promise<ContainerTurnoverDto[]> {
    const { data: containerTurnovers } = await this.api.containerTurnoversGetTurnoversByCarrierDirection({
      direction,
    })
    return containerTurnovers
  }

  async getEasiestContainerToReach(
    containerIds?: number[],
    amount?: number,
  ): Promise<SuggestedContainerDto[]> {
    const { data: containerTurnovers } = await this.api.containerTurnoversGetEasiestToReach({ containerIds, amount })
    return containerTurnovers
  }
}
